import styled from 'styled-components';

export const Numbers = styled.span`
  margin-top: 5px;
  margin-bottom: 5px;
`;
